function audioToReadableString(units: number): string {
  // 1 unit = 15s audio
  const totalSeconds = units * 15
  let finalUsage = ''
  const hours = totalSeconds / 3600
  const minutes = (totalSeconds % 3600) / 60
  const seconds = (totalSeconds % 3600) % 60
  if (hours >= 1) finalUsage += `${Math.floor(hours)}h `
  if (minutes >= 1 || hours > 1) finalUsage += `${Math.floor(minutes)}m `
  finalUsage += `${Math.floor(seconds)}s`
  return finalUsage
}

export default function unitsToReadableString(units: number, unitType: string): string {
  switch (unitType) {
    case 'audio': {
      return audioToReadableString(units)
    }
    default:
      return `${units}`
  }
}
